// extracted by mini-css-extract-plugin
module.exports = {"customButton":"styles_customButton__3oqD7","customCancelButton":"styles_customCancelButton__27LuU","customDangerButton":"styles_customDangerButton__1Hu3t"};